import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import SEO from '../components/SEO';
import { vietnamProvinces } from '../utils/vietnamProvinces';
import './Home.css';

const Home = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('');
  const [location, setLocation] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    fetchItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, location]);

  const fetchItems = async () => {
    try {
      setLoading(true);
      const params = {};
      if (category) params.category = category;
      if (location) params.location = location;
      if (search) params.search = search;
      
      const response = await axios.get('/api/items', { params });
      const data = response.data;
      // Đảm bảo luôn là mảng để tránh lỗi .map
      if (Array.isArray(data)) {
        setItems(data);
      } else {
        console.warn('API /api/items không trả về mảng, nhận được:', data);
        setItems([]);
      }
    } catch (error) {
      console.error('Lỗi khi tải món đồ:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchItems();
  };

  const categories = [
    { value: '', label: 'Tất cả' },
    { value: 'quan-ao', label: 'Quần áo' },
    { value: 'do-dung', label: 'Đồ dùng' },
    { value: 'sach', label: 'Sách' },
    { value: 'do-choi', label: 'Đồ chơi' },
    { value: 'noi-that', label: 'Nội thất' },
    { value: 'khac', label: 'Khác' }
  ];

  return (
    <>
      <SEO 
        title="Trang chủ"
        description="Nền tảng kết nối những món đồ không dùng đến với những người cần chúng. Chia sẻ yêu thương, giảm lãng phí."
      />
      <div className="home">
        <div className="hero">
          <h1>Chia Sẻ Yêu Thương</h1>
          <p>Nền tảng kết nối những món đồ không dùng đến với những người cần chúng</p>
        </div>

      <div className="container">
        <div className="search-section">
          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              placeholder="Tìm kiếm món đồ..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="search-input"
            />
            <button type="submit" className="btn btn-primary">Tìm Kiếm</button>
          </form>
          <div className="filter-section">
            <div className="category-filter">
              <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#666' }}>Danh mục:</h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                {categories.map(cat => (
                  <button
                    key={cat.value}
                    onClick={() => setCategory(cat.value)}
                    className={`category-btn ${category === cat.value ? 'active' : ''}`}
                  >
                    {cat.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="location-filter" style={{ marginTop: '20px' }}>
              <h4 style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600', color: '#666' }}>Tỉnh/Thành phố:</h4>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', maxHeight: '200px', overflowY: 'auto', padding: '4px' }}>
                {vietnamProvinces.filter(p => p.value !== '').map(province => (
                  <button
                    key={province.value}
                    onClick={() => setLocation(location === province.value ? '' : province.value)}
                    className={`category-btn ${location === province.value ? 'active' : ''}`}
                  >
                    {province.label}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="loading">Đang tải...</div>
        ) : !Array.isArray(items) || items.length === 0 ? (
          <div className="empty-state">
            <h3>Chưa có món đồ nào</h3>
            <p>Hãy là người đầu tiên đăng món đồ lên nền tảng!</p>
          </div>
        ) : (
          <div className="item-list">
            {items.map(item => (
              <article
                key={item.id}
                className="item-list-item"
                onClick={() => navigate(`/item/${item.id}`)}
              >
                {item.image_url ? (
                  <img 
                    src={item.image_url} 
                    alt={item.title} 
                    className="item-list-image"
                    loading="lazy"
                  />
                ) : (
                  <div className="item-list-image placeholder" aria-label="Không có hình ảnh">📦</div>
                )}
                <div className="item-list-content">
                  <h2 className="item-list-title">{item.title}</h2>
                  <p className="item-list-description">{item.description || 'Không có mô tả'}</p>
                  <div className="item-list-meta">
                    <span className="badge badge-info">{item.category || 'Khác'}</span>
                    {item.location && (
                      <span className="badge badge-secondary" style={{ fontSize: '11px' }}>
                        {vietnamProvinces.find(p => p.value === item.location)?.label || item.location}
                      </span>
                    )}
                    <span className="item-list-owner">{item.owner_name || item.owner_username}</span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </div>
    </>
  );
};

export default Home;

